<template>
  <div class="black-user-list" v-if="visible" @click.stop>
    <div class="item" v-for="item of list" :key="item.uuid">
      <div class="left">
        <img class="avatar" :src="item.avatarUrl" alt="" />
        <span>{{ item.nickname }}</span>
      </div>
      <button class="btn-delete" @click="removeBlack(item)">
        删除
      </button>
    </div>
  </div>
</template>
<script>
import {
  getBlackList,
  removeBlack as removeBlackRequest
} from '@/api/voice-room';
import VoiceRoomProvider from '@/components/VoiceRoom/voiceRoomProvider';
export default {
  name: 'UserRelation',
  props: {},
  data() {
    return {
      loading: false,
      visible: false,
      list: []
    };
  },
  watch: {},
  computed: {
    roomId() {
      return VoiceRoomProvider.roomInfo
        ? VoiceRoomProvider.roomInfo.roomUid
        : '';
    }
  },
  methods: {
    closeDialog() {
      this.visible = false;
      document.body.removeEventListener('click', this.closeDialog);
    },
    async show() {
      document.body.addEventListener('click', this.closeDialog);

      try {
        this.visible = true;
        this.loading = true;
        await this.getList();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.visible = false;
      }
    },
    async getList() {
      const { data } = await getBlackList({ roomUid: this.roomId });
      this.list = data || [];
    },

    async removeBlack(user) {
      try {
        await removeBlackRequest({ roomUid: this.roomId, uuid: user.uuid });
        this.$message.success('已移出小黑屋');
        this.getList()
      } catch (error) {
        this.$message.success('移出小黑屋失败');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.black-user-list {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #101024;
  width: 100%;
  color: white;
  font-size: 14px;
  border-radius: 20px;
  height: 300px;
  overflow: auto;
  z-index: 10;
  .item {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    .left {
      align-items: center;
      display: flex;
    }
    img {
      width: 30px;
      height: 30px;
      object-fit: cover;
      border-radius: 50%;
      margin-right: 10px;
    }
    button {
      color: white;
    }
  }
}
</style>
